import type { IMTokens } from '@/interface/IMTokens';
import { LeagueSize, SportType } from '@/interface/enum';
import { useOddsApiStore } from '@/store/oddsApiStore';

const leagueSizeTokenKey: Record<LeagueSize, keyof IMTokens> = {
    [LeagueSize.Big]: 'b',
    [LeagueSize.Medium]: 'm',
    [LeagueSize.Small]: 's',
};

export function useOddsToken() {
    function getOddsToken(sportType: SportType, leagueSize: LeagueSize): string {
        const oddsApiStore = useOddsApiStore();
        const tokens = sportType === SportType.Soccer ? oddsApiStore.soccerMOddsTokens : oddsApiStore.othersMOddsTokens;
        return tokens[leagueSizeTokenKey[leagueSize]];
    }

    return {
        getOddsToken,
    };
}
